var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nextPage",attrs:{"id":"nextPage"}},[_c('div',{staticClass:"npText"},[_c('h2',[_vm._v(_vm._s(_vm.page))]),_c('h4',[_vm._v("next")])])])}
var staticRenderFns = []

export { render, staticRenderFns }